import { Reveal } from "./Reveal";

export const SectionHead = ({ eyebrow, title, text, dark, center }) => (
  <Reveal className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
    <p className={`eyebrow ${dark ? "text-violet-300" : "text-[#7C3AED]"}`}><span className="h-1.5 w-1.5 rounded-full bg-[#2563EB]" />{eyebrow}</p>
    <h2 className={`mt-5 text-3xl font-extrabold leading-[1.05] sm:text-4xl lg:text-5xl ${dark ? "text-white" : "text-[#13052A]"}`}>{title}</h2>
    {text && <p className={`mt-5 text-base leading-relaxed md:text-lg ${dark ? "text-violet-100" : "text-slate-600"}`}>{text}</p>}
  </Reveal>
);
